import axios from "axios";

class CiudadanosService {
 
  usersServiceUrlW() {
    return "https://ws-usuario.cveo5ltgpic08.us-east-1.cs.amazonlightsail.com";
  }

  usersServiceUrlL() {
    return "http://localhost:8080";
  }

  usersServiceURL() {
    return this.usersServiceUrlW()
  }

  apiURL() {
        let API_URL = process.env.REACT_APP_CIUDADANOS360_ENDPOINT
      ? process.env.REACT_APP_ESTACIONAMIENTO_ENDPOINT
      : `https://api.ciudadanos360.com`;
    
      let baseURL = "";
    if (process.env.NODE_ENV === "development") {
      baseURL = `${API_URL}`;
    } else baseURL = process.env.REACT_APP_CIUDADANOS360_ENDPOINT;
      return baseURL
    }

   


    getDatosCiudadano(hashLogin) {
      return axios.get(this.apiURL()+"/login/GetDatosCiudadano/"+hashLogin)
    }

    getTurnosCiudadanos(hashLogin) {
      return axios.get(this.apiURL()+"/turnos/GetIsTurnosPaciente/"+hashLogin)
    }

    cancelarTurno(datos) {
      return axios.post(this.apiURL()+"/turnos/IsTurnoCancelacion/", datos)
    }

    convertir(fecha) {
      return (fecha.substring(8,10)+ " de "+ this.mes(fecha.substring(5,7))+" "+fecha.substring(0,4));
    }

    mes(numero) {
      if (numero=="01") return "enero"; 
      else if (numero=="02") return "febrero"
      else if (numero=="03") return "marzo"
      else if (numero=="04") return "abril"
      else if (numero=="05") return "mayo"
      else if (numero=="06") return "junio"
      else if (numero=="07") return "julio"
      else if (numero=="08") return "agosto"
      else if (numero=="09") return "septiembre"
      else if (numero=="10") return "octubre"
      else if (numero=="11") return "noviembre"
      else if (numero=="12") return "diciembre"
      else return numero
    }

    obtenerTokenEstudios(){
     /* int const postData= {
        username: "pilar-mobile@wellbin.co",
        password: "2qvPon!ru@1QW1d@WKq4",
        grant_type: "password"
      };*/

      /* prod const postData= {
       username: "pilar-mobile@wellbin.co",
       password: "a$c!XJf65BUVa%Dc5H88Rq9fKV4sDaMbzLZ0IoLPVGjac&UfNW",
        grant_type: "password"
      };*/
       const postData= {
       username: "pilar-mobile@wellbin.co",
       password: "a$c!XJf65BUVa%Dc5H88Rq9fKV4sDaMbzLZ0IoLPVGjac&UfNW",
        grant_type: "password"
      };

      //int return axios.post("https://staging.wellbin.co/api/v2/auth/token",
      //prod return axios.post("https://wellbin.co/api/v2/auth/token",
      return axios.post("https://wellbin.co/api/v2/auth/token",
      postData,
      //int {headers: {'Authorization': 'Basic dWdjM3EyZjYzbWsydnllcGFlOWhoMWozOnNlY3JldC1wYXNzd29yZA=='}})
      //prod {headers: {'Authorization': 'Basic dWdjM3EyZjYzbWsydnllcGFlOWhoMWozOkJ2T3I1YzQ1OFBNVFRXamxpMU1aSkI3WkQxQzJEWA=='}})
      {headers: {'Authorization': 'Basic dWdjM3EyZjYzbWsydnllcGFlOWhoMWozOkJ2T3I1YzQ1OFBNVFRXamxpMU1aSkI3WkQxQzJEWA=='}})
    }

    obtenerIframeEstudios(token, datos){
      //int return axios.post('https://staging.wellbin.co/api/v2/integrations/embedded/patient-study-list-url',
      //prod return axios.post('https://wellbin.co/api/v2/integrations/embedded/patient-study-list-url',
      return axios.post('https://wellbin.co/api/v2/integrations/embedded/patient-study-list-url',
      datos, {headers: {'Authorization': 'Bearer '+token}})
    }

    obtenerTurnosCuidarnos(dni, fechaNacimiento) {
      return axios.get('https://api.cuidarnos.com/turnos/TurnosPersona/'+dni+'/'+fechaNacimiento,
      {headers: {'X-Cuidarnos-Access-Key': '118b47wyvxpptz0jxoniv0gkrdoaf1fa6'}})
    }

    cancelarTurnosCuidarnos(datos){
      return axios.post('https://api.cuidarnos.com/turnos/TramitesPilarCancelarTurno',datos)
    }

    registrarInscripcionClub(hash, club) {
      return axios.post(this.usersServiceURL()+"/users/set-user-club",
      {
        hashLogin : hash,
        clubReq : club
    })
    }
    
}
export default new CiudadanosService()